import { styled } from '@stitches/react';
import { useMemo } from 'react';
import { useElements, useScene } from '../../hooks';

export const ProgressbarElement = ({ elementID }: { elementID: string }) => {
  const scene = useScene();
  const [element] = useElements({ id: elementID });

  const Progressbar = useMemo(
    () => styled('div', element?.props?.class as {}),
    [element?.props?.class]
  );

  return (
    <Progressbar
      element-type="appTaskProgressBar"
      id={element?.id}
      {...scene.launcherStateProps}
    />
  );
};
